  <div *ngIf="showName" [ngStyle]="{'color': foregroundcolor}" class="quesIndexCss" id="question">
    <span class="quesIndexSpan">
   <span style="font-size: 24px;">{{questionIndex}}</span>
   <span style="font-size:medium"> of {{totalQuestion}} </span>
  </span>
   <span style="margin-left: 2.5%; max-width: 90% ; min-width: 90%;">{{question.questionText}}
   <span class="errorrequired" *ngIf="question.isQuestionRequired==='Y'"> *</span>
  </span>
  </div>
<br />
<div class="rating-view" style="margin-top: -2%;
margin-bottom: -2%;">
  <ng-container *ngIf="isEditing">
    <div class="response-labels">
      <label> Initial Text </label>
      <input type="text" name="initialText" [(ngModel)]="ratingConfig.initialText" (change)="emitUpdatedData()" placeholder="Enter initial text" />
    </div>
    <div class="response-labels">
      <label> Final Text </label>
      <input type="text" name="finalText" [(ngModel)]="ratingConfig.finalText" (change)="emitUpdatedData()" placeholder="Enter final text" />
    </div>
  </ng-container>
  <div [ngClass]="showName  ? 'preview': 'altpreview'" >
   <!--  <div class="content-text" >
     {{ratingConfig.initialText}} 
    </div> -->
    <!-- <div class="rating" [ngClass]="{'selected': ratingConfig.rating == (i + 1),'ReadOnlyControl':IsReadOnly }"  -->
      <div class="rating" [ngClass]="{'selected':ratingConfig.rating == (i + 1),'ReadOnlyControl':IsReadOnly}"
      
      [style.background-color] ="controlBGColor"  class="{{theme}}" [style.border]="tableBorder" (click)="updateValue(i + 1)"
    *ngFor="let num of (getNumbers | numbersPipe); let i = index">
  <!--  <i class="fa fa-star-o" aria-hidden="true" value="1" ></i>  -->
    <div> {{i + 1}} </div>
      
      
    </div>
   <!--    <div class="content-text" >
   {{ratingConfig.finalText}}
    </div>  -->
  </div>
</div>
<div *ngIf="errormgvisible" class="dvError">
  <div class="errormsg" *ngFor="let error of validationerrormessage">{{error}}</div>
</div>
